'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
require('../utils/index.js');
var lodash = require('lodash');
var constants = require('../utils/constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);

/**
 * Represent a user's JSON.
 *
 * @export
 */

/**
 * GSQL user.
 *
 * @export
 */
var User = /*#__PURE__*/function () {
  function User(info) {
    _classCallCheck__default["default"](this, User);
    this.username = info.name;
    this.superuser = !!info.isSuperUser;
    this.roles = info.roles || {};
    this.privileges = info.privileges || {};
    // Before TG 4.1.0, info.secrets is an object, where the key is the graph name and the value is an array of secrets.
    // After TG 4.1.0, secrets are not graph-specific, info.secrets is an array.
    if (_Array$isArray__default["default"](info.secrets)) {
      this.globalSecrets = info.secrets;
    } else {
      this.secrets = this.parseToSecret(info.secrets);
    }
  }

  /** Return the username. */
  return _createClass__default["default"](User, [{
    key: "getUsername",
    value: function getUsername() {
      return this.username;
    }

    /**
     * Set the current graph the user is using.
     *
     * @memberof User
     */
  }, {
    key: "setCurrentGraph",
    value: function setCurrentGraph(graphName) {
      this.currentGraph = graphName;
    }

    /**
     * Return the current graph the user is using.
     *
     * @type {string}
     * @memberof User
     */
  }, {
    key: "getCurrentGraph",
    value: function getCurrentGraph() {
      return this.currentGraph;
    }

    /**
     * Return all of the user's roles.
     *
     * @readonly
     * @type {UserRole}
     * @memberof User
     */
  }, {
    key: "getRoles",
    value: function getRoles() {
      return this.roles;
    }

    /** Return the user's roles for a given graph. */
  }, {
    key: "getRolesForGraph",
    value: function getRolesForGraph(graphName) {
      var roles = [];
      if (graphName) {
        roles = lodash.cloneDeep(this.roles[graphName] || []);
      }
      return roles;
    }
  }, {
    key: "getPrivileges",
    value: function getPrivileges() {
      return this.privileges;
    }
  }, {
    key: "getPrivilegesForGraph",
    value: function getPrivilegesForGraph(graphName) {
      var _this$privileges$grap;
      return ((_this$privileges$grap = this.privileges[graphName]) === null || _this$privileges$grap === void 0 ? void 0 : _this$privileges$grap.privileges) || [];
    }
  }, {
    key: "getChildPermissionsForGraph",
    value: function getChildPermissionsForGraph(graphName) {
      var _this$privileges$grap2;
      return ((_this$privileges$grap2 = this.privileges[graphName]) === null || _this$privileges$grap2 === void 0 ? void 0 : _this$privileges$grap2.childPermissions) || {};
    }

    /**
     * Return the user's highest level role for a given graph.
     *
     * @param {string} [graphName=this.currentGraph]
     * @returns {GSQLBuiltinRole}
     * @memberof User
     */
  }, {
    key: "getUserRole",
    value: function getUserRole() {
      var graphName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentGraph;
      return this.roles[graphName][0];
    }
  }, {
    key: "getUserRoles",
    value: function getUserRoles() {
      var graphName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentGraph;
      return this.roles[graphName];
    }
  }, {
    key: "hasPrivilege",
    value: function hasPrivilege(privilege) {
      var _context, _context2;
      var graphName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentGraph;
      return this.privileges[graphName] && _includesInstanceProperty__default["default"](_context = this.privileges[graphName].privileges).call(_context, privilege) || this.privileges[constants.GLOBAL_GRAPH_NAME] && _includesInstanceProperty__default["default"](_context2 = this.privileges[constants.GLOBAL_GRAPH_NAME].privileges).call(_context2, privilege);
    }

    /** Return the user's secrets for a given graph. */
  }, {
    key: "getSecrets",
    value: function getSecrets(graphName) {
      var secrets = [];
      if (graphName) {
        secrets = lodash.cloneDeep(this.secrets.get(graphName) || []);
      }
      return secrets;
    }

    /** Return the global secrets. */
  }, {
    key: "getGlobalSecrets",
    value: function getGlobalSecrets() {
      return lodash.cloneDeep(this.globalSecrets || []);
    }

    /** Return whether the user is Super User or not. */
  }, {
    key: "isSuperUser",
    value: function isSuperUser() {
      return this.superuser;
    }

    /**
     * Return all graph the user has access to.
     *
     * @returns {string[]}
     * @memberof User
     */
  }, {
    key: "getGraphList",
    value: function getGraphList() {
      return _Object$keys__default["default"](this.roles);
    }

    /** Update user's information. */
  }, {
    key: "updateInfo",
    value: function updateInfo(info, graphName) {
      this.superuser = !!info.isSuperUser;
      if (info.roles[graphName]) {
        this.roles[graphName] = info.roles[graphName];
      } else {
        delete this.roles[graphName];
      }
      if (info.privileges[graphName]) {
        this.privileges[graphName] = info.privileges[graphName];
      } else {
        delete this.privileges[graphName];
      }
      if (_Array$isArray__default["default"](info.secrets)) {
        this.globalSecrets = info.secrets;
      } else if (info.secrets[graphName]) {
        this.secrets.set(graphName, info.secrets[graphName]);
      } else {
        this.secrets["delete"](graphName);
      }
    }

    /** Parse secret JSON. */
  }, {
    key: "parseToSecret",
    value: function parseToSecret(secrets) {
      var result = new _Map__default["default"]();
      if (secrets) {
        var _context3;
        _forEachInstanceProperty__default["default"](_context3 = _Object$keys__default["default"](secrets)).call(_context3, function (graphName) {
          return result.set(graphName, secrets[graphName]);
        });
      }
      return result;
    }
  }]);
}();

exports.User = User;
